export const getHostnameFromUrl = (url: string): string => {
  return url.replace(/^https?:\/\/|\/$/g, '');
};
